module.exports = __webpack_public_path__ + "img/ic_topic_food.8f1930cb.svg";